<template>
  <div class="forgotpassword">
    <ForgotPasswordThanksPage />
  </div>
</template>

<script>
import ForgotPasswordThanksPage from '../components/elements/pages/ForgotPasswordThanksPage.vue'
export default {
  name: 'ForgotPasswordThanks',
  metaInfo: {
    title: 'Forgot Password Thanks'
  },
  components: {
    ForgotPasswordThanksPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
